import { createContext } from "react";
import { ReactStateType } from '@xnav/types/src/frontend'
import { MediaMeta } from "@/pages/mediaManager";

export const MediaContext = createContext<ReactStateType<MediaMeta[] | undefined>>([[], () => undefined])
